<template>
    <section id="content">
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2 final_step_warning text-center">
                        <i class="bi bi-exclamation-triangle-fill"></i>
                        <h2 class="blueFont ">قريباً ...</h2>               
                    </div>
                   
                </div>
          
                
                <div class="row my-4 justify-content-center">
                    <div class="col-12 col-sm-4 mb-3">                    
                        <div class="d-flex justify-content-center">                    
                            <button @click="ToMainPage" type="button" class="btn btn-light mx-3 align-self-center">
                                غلق
                            </button>
                        </div>
                    </div> 
                </div>
               </div>
            </div>
    </section>

  <router-view></router-view>
</template>

<script>
export default {
  name: 'SoonView',
  created(){
    window.scrollTo({ top: 0, behavior: "smooth" });
  },

  methods:{
    ToMainPage(){
        this.$router.push({name:'dashboard'});
    },
  }
}
</script>